module.exports = __webpack_public_path__ + "media/images/bet1x2__checkedOption-b9f6e2be3461b69e348cf54f65d4ea19.png";